// extracted by mini-css-extract-plugin
module.exports = {"roleModal":"RoleModal_roleModal__FD81H"};